import { Caption, SessionActivity } from './types';

export const hasCollaboration = (activity: SessionActivity) => {
    const isQnaEnabled = activity?.qna?.enable;
    const isChatEnabled = activity?.chat?.enable;
    return isQnaEnabled || isChatEnabled;
};

export const normalizeCaptions = (captions: Caption[] = []) =>
    captions.map(({ label, captionUrl, languageCode }) => ({
        label,
        captionUrl,
        langCode: languageCode,
    }));
